module.exports = "/_next/static/images/logo-my-med-dark-7ba39671a025c71e0ae255ac5cae713e.svg";